// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"52":"9d1394f478ce4e3c","405":"b5fb43b1cd7cd9bc","703":"4d49d70f242cecd9","888":"6f87e23fb40a35ae"}[chunkId] + ".css";
};